import type { FaireProductEntity } from "../../entity_types/product";

export const p_4awp6wq3b5: FaireProductEntity = {
  token: "p_4awp6wq3b5",
  type: "product",
  name: "Freesize Elephant Print Harem Trouser",
  brandToken: "b_2y1von4s08",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0bfa89df0d727634a9c4745f32ee1e0570eae9610ddcf7329c20964b91229706.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec3ee0f5582d790108db4624f80050a644fb2c524f3644d574cc70500b0e305b.jpeg",
    "https://cdn.faire.com/fastly/fb363f834067363329b2f904b1fec0772703aee8aead5addbaf58ed24ca90660.jpeg",
    "https://cdn.faire.com/fastly/da1443fabdf96819b9cbeda7b8396b8450566c7e3ed18598d2fb3eb203637f64.jpeg",
  ],
  priceDollars: 15.37,
  description:
    "Freesize (UK size 12-14 maximum).\nThese light-fabric harem trousers are in a trendy elephant print and colors of purple, red, navy, teal, and blue. They have an elasticated waist with a white plaited pull cord and are elasticated and gathered at the ankles.\n Detailed with a side patch pocket these soft, lightweight pants allow free movement and maximum comfort. Versatile and quick drying, they are ideal for festivals, leisure, beach holidays, travel, yoga, pilates, nightwear or loungewear.\n100% Rayon\nDry clean or hand wash in cool water using a gentle, pH-neutral, or mild alkaline detergent. Rinse in cool water and avoid wringing. Hang to dry. Do not tumble dry. Cool iron on reverse.\nWith a large team of skilled workers, our supplier has made an impact in the locality by exporting quality rayon clothing. They have become a well-known employer whose processes of manufacture are checked to international standards.",
  tags: [],
  msrpDollars: 30.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:24.520Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
